<template>
  <DetailsPane
    :title="title || 'User Details'"
    :hide-title="hideTitle"
    :hide-close="hideClose"
    :height="height"
    :auto-height="autoHeight"
    @close="$emit('close')"
  >
    <div class="details-pane-table p-4">
      <div class="row mb-2">
        <div class="col-4 col-attribute">Name:</div>
        <div class="col-8 col-value">{{ user.name }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">{{ userIdLabel }}:</div>
        <div class="col-8 col-value">{{ userIdValue }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Email:</div>
        <div class="col-8 col-value">{{ user.email }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Phone:</div>
        <div class="col-8 col-value">{{ user.phone }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Company:</div>
        <div class="col-8 col-value">
          <a v-if="$root.isAdminager" :href="companyUrl">{{ user.company.name }}</a>
          <span v-else>{{ user.company.name }}</span>
          <span v-if="!!user.company.hvac_id">
            <br />
            {{ user.company.hvac_id }}
          </span>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Title:</div>
        <div class="col-8 col-value">{{ user.title }}</div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Address:</div>
        <div class="col-8 col-value" v-html="user.company.address"></div>
      </div>
      <div class="row mb-2">
        <div class="col-4 col-attribute">Brand:</div>
        <div class="col-8 col-value">{{ user.brand }}</div>
      </div>
      <div v-if="showSurveyLink" class="row">
        <div class="col-12">
          <hr />
          <h4 class="mb-3">
            <strong>Survey Link</strong>
          </h4>
          <p>
            The following URL can be used to provide students with a way to view
            all open surveys for your company's online courses and classroom
            events you are assigned to train.
          </p>
          <p>
            <a class="font-weight-bold" :href="surveyUrl" target="_blank">{{
              surveyUrl
            }}</a>
          </p>
        </div>
      </div>
      <div v-if="!hideDetailsButton" class="row pt-4">
        <div class="col-12 text-center">
          <a :href="detailsUrl" class="btn btn-info">{{ detailsLabel }}</a>
        </div>
      </div>
    </div>
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
import DetailsPaneMixin from "mixins/DetailsPane";
import Str from "helpers/Str";

export default {
  mixins: [DetailsPaneMixin],
  components: { DetailsPane },
  props: {
    user: { type: Object, required: true },
    section: { type: String, default: "training" },
    hideDetailsButton: { type: Boolean, default: false },
  },
  computed: {
    detailsUrl() {
      return this.section == "admin"
        ? this.route("admin.users.edit", { user: this.user.id })
        : this.route("training.users.show", { user: this.user.id });
    },
    detailsLabel() {
      return this.section == "admin" ? "Edit User" : "View Full Details";
    },
    userIdLabel() {
      return this.user.display_id.split(":")[0].trim();
    },
    userIdValue() {
      return this.user.display_id.split(":")[1].trim();
    },
    companyUrl() {
      return this.route("training.companies.show", {
        company: this.user.company_id,
      });
    },
    showSurveyLink() {
      return (
        !!this.user.trainer_type &&
        (this.$root.isAdmin || this.$root.user.id == this.user.id)
      );
    },
    surveyUrl() {
      return this.route("training.surveys", {
        user: this.user.id,
      });
    },
  },
};
</script>
